import React from 'react';
import {useSelector} from "react-redux";
import {getRowNumber} from "mindsets-js-sdk";

import Row from './Row';

export default function () {
    const items = useSelector(state => state.question_practice_skill_groups);
    const current = useSelector(state => state.question_practice_skill_groups_current);
    const limit = useSelector(state => state.question_practice_skill_groups_limit);

    return (
        <div className="table-responsive">
            <table className="table table-bordered table-hover">
                <thead>
                <tr className="text-center">
                    <th scope="col">No</th>
                    <th scope="col">Challenge Name</th>
                    <th scope="col">Practice</th>
                    <th scope="col">Actions</th>
                </tr>
                </thead>
                <tbody>
                {items.map((item, index) => {
                    return (
                        <Row
                            key={index}
                            row_number={getRowNumber(index, current, limit)}
                            item={item}
                        />
                    );
                })}
                </tbody>
            </table>
        </div>
    );
}
